export default {
	our_clients(state) {
		return state.our_clients
	},
}
